'use client'

import { createContext } from 'react'

import { utmize as _utmize } from '@/lib/analytics/utmize'

export interface AffiliateLinkProps {
  url: string
  medium?: string
  campaign?: string
  term?: string
  content?: string
  release?: string
}

const defaultBuildLink = (props: AffiliateLinkProps) => _utmize({ ...props, pathname: '', featureFlags: {} })

interface AffiliateLinkContextType {
  buildLink: (props: AffiliateLinkProps) => string
}

export const AffiliateLinkContext = createContext<AffiliateLinkContextType>({ buildLink: defaultBuildLink })
